import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  cancelButton: {
    backgroundColor: `${theme.palette.icon.dark} !important`,
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    marginRight: theme.spacing(3),
  },
  footer: {
    marginTop: theme.spacing(5),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
  },
  uploader: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  errorContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.error.dark}`,
    color: theme.palette.error.dark,
  },
  errorTitle: {
    fontSize: '14px',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.error.dark,
  },
  errorGroup: {
    marginTop: theme.spacing(1),
  },
  rowTitle: {
    fontSize: '13px',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.error.dark,
  },
  errors: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    fontWeight: 400,
    '& strong': {
      color: theme.palette.error.dark,
      fontWeight: 600,
    },
  },
  errorList: {
    marginTop: theme.spacing(0.5),
    marginBottom: 0,
    paddingLeft: theme.spacing(2.5),
  },
}))
